// /src/pages/private/admin/organisationMembersTabs/requests/structureChangeRequestsApi.js

import axios from 'axios';

export async function fetchStructureChangeRequests(status = 'all') {
  const { data } = await axios.post(
    '/api/admin/organisation-members/structure-change-requests/list',
    { status },
    { withCredentials: true },
  );
  return data;
}

export async function approveStructureChangeRequest(id, resolveComment = null) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/structure-change-requests/approve',
    { id, resolveComment },
    { withCredentials: true },
  );
  return data;
}

export async function dismissStructureChangeRequest(id, resolveComment) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/structure-change-requests/dismiss',
    { id, resolveComment },
    { withCredentials: true },
  );
  return data;
}

export const ORG_STRUCTURE_CHANGE_REQUESTS_WS_CHANNEL =
  'orgStructureChangeRequests:admin';

export async function orgStructureChangeRequestsWsLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/structure-change-requests/ws-last-seen',
    typeof lastSeenWsLogId === 'undefined' ? {} : { lastSeenWsLogId },
    { withCredentials: true },
  );
  return data;
}

export async function getOrgStructureChangeRequestsWsDiff() {
  const { data } = await axios.post(
    '/api/admin/organisation-members/structure-change-requests/ws-diff',
    {},
    { withCredentials: true },
  );
  return data;
}

export async function wsResumeOrgStructureChangeRequests(sinceSeq = 0) {
  const channel = encodeURIComponent(ORG_STRUCTURE_CHANGE_REQUESTS_WS_CHANNEL);
  const { data } = await axios.post(
    `/api/ws-resume/${channel}`,
    { sinceSeq },
    { withCredentials: true },
  );
  return data;
}
